import { React, useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import CheckIcon from "@mui/icons-material/Check";
import classes from "./CreateUpdateFramework.module.css";
import AsttButton from "../../AsttButton/AsttButton";
import { useNavigate } from "react-router-dom";
import SnackBar from "components/SnackBar/SnackBar";
import {
  getAllParentClients,
  getAllSiteCodes,
  getclientData,
  getprojectData,
  getprogramData,
  getFramework,
  updateFramework,
  createFramework,
  getAllClassTypes,
} from "../../../services/learnPointUserServices";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import BackdropComponent from "../../Spinner/Spinner";
import { Chip, Tooltip } from "@mui/material";
import moment from "moment";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useAuth } from "context/AuthContext";

const CustomButton = styled(Button)(() => ({
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  fontSize: "12px",
  letterSpacing: "0.10em",
  borderRadius: "8px",
  fontWeight: "600",
  textTransform: "none",
  color: "white",
  backgroundColor: "#3299FF",
  "&:hover": {
    backgroundColor: "#2878CC",
  },
}));

const CustomOutlinedButton = styled(Button)(() => ({
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  fontSize: "12px",
  letterSpacing: "0.10em",
  borderRadius: "8px",
  fontWeight: "600",
  textTransform: "none",
  borderColor: "#3299FF",
  color: "#3299FF",
  padding: "6px 20px",

  "&:hover": {
    borderColor: "#3299FF",
    backgroundColor: "#E0F2FF",
  },
}));

export const StyledChip = styled(Chip)(() => ({
  borderRadius: "32px",
  whiteSpace: "normal",
  overflow: "hidden",
  textOverflow: "ellipsis",
  opacity: 1,
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: "gray",
}));

export const LimitChip = styled(Chip)(() => ({
  fontWeight: "bold",
  color: "#3299FF",
}));

export default function CreateUpdateFramework(props) {
  const { hasPermission } = useAuth();

  const action = props.action;
  const update = "update";
  const create = "create";
  const frameworkId = props.frameworkId;
  const [readOnlyFramework, setReadOnlyFramework] = useState(true);
  const [frameworkDetails, setFrameworkDetails] = useState([]);
  const [loader, setLoader] = useState(false);
  const [parentClientDetail, setParentClientDetail] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [clientData, setClientData] = useState([]);
  const [programData, setProgramData] = useState([]);
  const [projectData, setProjectData] = useState([]);
  const [allProjectData, setAllProjectData] = useState([]);
  const [siteData, setSiteData] = useState([]);
  const [classTypeData, setClassTypeData] = useState([]);

  const initialClassTypeValue = {
    ClassTypeId: 1,
    ClassTypeCode: "NH",
    ClassTypeName: "New Hire",
  };

  const [classTypeValue, setClassTypeValue] = useState(initialClassTypeValue);
  const initialClientValue = {
    ClientId: 0,
    ClientCode: "",
    ClientName: "",
  };

  const initialProgramValue = {
    ProgramId: 0,
    ProgramName: "",
    ProgramCode: "",
  };

  const initialProjectValue = [
    {
      ProjectId: 0,
      ProjectName: "",
      ProjectCode: "",
    },
  ];

  const initialParentClientValue = {
    ParentClientId: 0,
    ParentClientName: "",
    ParentClientCode: "",
  };

  const initialCountryValue = {
    Country: "",
  };

  const initialSiteValue = [
    {
      GeoLocCd: "",
      GeoLocName: "",
      GeoLocationId: 0,
      CountryCode: "",
    },
  ];

  const [clientValue, setClientValue] = useState(initialClientValue);

  const [programValue, setProgramValue] = useState(initialProgramValue);

  const [projectValue, setProjectValue] = useState([]);

  const [parentClientValue, setParentClientValue] = useState(
    initialParentClientValue,
  );

  const [selectedCountry, setSelectedCountry] = useState(initialCountryValue);

  const [selectedSite, setSelectedSite] = useState([]);

  const frameworkNameRef = useRef("");
  const frameworkDescriptionRef = useRef("");
  const effectiveDateRef = useRef("");
  const expiryDateRef = useRef("");
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const [allGeoLocData, setAllGeoLocData] = useState([]);
  const navigate = useNavigate();

  const populateFrameworkFields = (frameworkData) => {
    const details = frameworkData[0];
    const clientProgramDetails = details?.searchProjectResponses[0];
    const countryDetails = details?.searchGeoLocationResponses[0];

    frameworkNameRef.current.value = details?.framework;
    frameworkDescriptionRef.current.value = details?.description;
    effectiveDateRef.current.value = details?.effectiveDate
      ? moment(details?.effectiveDate).format("YYYY-MM-DD")
      : "YYYY-MM-DD";
    expiryDateRef.current.value = details?.expireDate
      ? moment(details?.expireDate).format("YYYY-MM-DD")
      : "YYYY-MM-DD";
    setupCPPFields(clientProgramDetails?.parentClientId);
    setupSiteFields(countryDetails?.country);
    setParentClientValue({
      ParentClientId: clientProgramDetails?.parentClientId,
      ParentClientName: clientProgramDetails?.parentClientName,
      ParentClientCode: clientProgramDetails?.parentClientCode,
    });
    setClientValue({
      ClientId: clientProgramDetails?.clientId,
      ClientCode: clientProgramDetails?.clientCode,
      ClientName: clientProgramDetails?.clientName,
    });
    setProgramValue({
      ProgramId: clientProgramDetails?.programId,
      ProgramName: clientProgramDetails?.programName,
      ProgramCode: clientProgramDetails?.programCode,
    });

    const frameworkProjects = prepareProjectData(
      details?.searchProjectResponses,
    );

    const frameworkSites = prepareSiteData(details?.searchGeoLocationResponses);
    setProjectValue(frameworkProjects);

    setSelectedCountry({
      Country: countryDetails?.country,
    });
    let defaultclassType = initialClassTypeValue;
    defaultclassType.ClassTypeId = details?.frameworkClassTypeId;
    defaultclassType.ClassTypeName = details?.frameworkClassType;
    setClassTypeValue(defaultclassType);
    setUpSites(countryDetails?.country);
    setSelectedSite(frameworkSites);
  };

  const prepareSiteData = (data) => {
    return data?.map((site) => ({
      GeoLocCd: site?.siteCode,
      GeoLocName: site?.site,
      GeoLocationId: site?.geoLocationId,
    }));
  };

  const prepareProjectData = (data) => {
    const projects = data?.map((project) => ({
      ProjectId: project?.projectId,
      ProjectName: project?.projectName,
      ProjectCode: project?.projectCode,
    }));

    return projects;
  };

  function validateAccess() {
    if (hasPermission("LD_Group_Admin")) {
      setReadOnlyFramework(false);
    }
    window.localStorage.removeItem("url");
  }

  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      if (!cancelled) {
        setLoader(true);
      }

      try {
        // API call to get all parent client details, all sites, all country codes.

        const parentClientDetails = await getAllParentClients();

        if (cancelled) return;

        if (parentClientDetails?.message === "Success") {
          if (!cancelled) {
            setParentClientDetail(parentClientDetails?.data);
          }
        }

        const classTypeDetails = await getAllClassTypes();

        if (cancelled) return;

        if (classTypeDetails?.message === "Success") {
          if (!cancelled) {
            setClassTypeData(classTypeDetails?.data);
          }
        }

        if (action === create) {
          const countryCode = await getAllSiteCodes();

          if (cancelled) return;

          if (countryCode?.message === "Success") {
            if (!cancelled) {
              setAllGeoLocData(countryCode?.data);
              setCountryData(prepareCountryData(countryCode?.data));
            }
          }
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch data:", error);
        }
      } finally {
        if (!cancelled) {
          setLoader(false);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    let cancelled = false;

    const loadFrameworkData = async () => {
      if (action === update && frameworkId !== 0) {
        try {
          const frameworkData = await getFramework(frameworkId);

          if (cancelled) return;

          if (frameworkData?.message === "Success") {
            if (!cancelled) {
              setFrameworkDetails(frameworkData?.data);
              populateFrameworkFields(frameworkData?.data);
            }
          }
        } catch (error) {
          if (!cancelled) {
            console.error("Failed to fetch framework details:", error);
          }
        }
      }

      validateAccess();
    };

    loadFrameworkData();

    return () => {
      cancelled = true;
    };
  }, [action, frameworkId]);

  const resetCascadingFilters = () => {
    setClientValue(initialClientValue);

    setProgramValue(initialProgramValue);

    setProjectValue([]);
  };

  const handleParentClientChange = async (event, value) => {
    if (value) {
      resetCascadingFilters();
      setParentClientValue(value);
      setupCPPFields(value?.ParentClientId);
    } else {
      setParentClientValue({
        ParentClientName: "",
        ParentClientCode: "",
      });
    }
  };

  const setupCPPFields = async (value) => {
    setLoader(true);
    const projectResults = await getprojectData(value);
    if (projectResults?.message === "Success") {
      setAllProjectData(projectResults?.data);
      setProjectData(projectResults?.data);
    }

    const clientResults = await getclientData(value);
    if (clientResults?.message === "Success") {
      setClientData(clientResults?.data);
    }

    const programResults = await getprogramData(value);
    if (programResults?.message === "Success") {
      setProgramData(programResults?.data);
    }
    setLoader(false);
  };

  const setupSiteFields = async (value) => {
    setLoader(true);
    const countryCode = await getAllSiteCodes();
    if (countryCode?.message === "Success") {
      setLoader(false);
      setAllGeoLocData(countryCode?.data);
      setCountryData(prepareCountryData(countryCode?.data));
      setSiteData(countryCode?.data?.filter((item) => item.Country === value));
    }
    setLoader(false);
  };

  const handleCountryChange = (event, value) => {
    if (value) {
      setSelectedSite([]);
      setSelectedCountry(value);
      setUpSites(value?.Country);
    } else {
      setSelectedCountry({
        Country: "",
      });
    }
  };

  const setUpSites = (country) => {
    const sites = allGeoLocData?.filter((item) => item?.Country === country);
    setSiteData(sites);
  };

  const prepareCountryData = (data) => {
    const countries = data?.map((country) => ({
      CountryCode: country?.CountryCode,
      Country: country?.Country,
    }));

    let distinctCountries = [
      ...new Map(countries?.map((item) => [item["Country"], item])).values(),
    ];

    return distinctCountries;
  };

  const handleReset = () => {
    setLoader(true);

    if (action === update) {
      populateFrameworkFields(frameworkDetails);
    } else {
      setClientData([]);
      setProgramData([]);
      setProjectData([]);
      setAllProjectData([]);
      setSiteData([]);
      setClassTypeValue(initialClassTypeValue);
      setParentClientValue({
        ParentClientName: "",
        ParentClientCode: "",
      });
      resetCascadingFilters();

      setSelectedCountry(initialCountryValue);
      setSelectedSite([]);

      if (frameworkNameRef.current !== null) {
        frameworkNameRef.current.value = "";
      }
      if (frameworkDescriptionRef.current !== null) {
        frameworkDescriptionRef.current.value = "";
      }

      if (effectiveDateRef.current !== null) {
        effectiveDateRef.current.value = "";
      }

      if (expiryDateRef.current !== null) {
        expiryDateRef.current.value = "";
      }
    }

    setLoader(false);
  };

  const validateFields = () => {
    let message = "Valid";
    if (frameworkDescriptionRef.current.value === "") {
      message = "Please provide framework description";
    } else if (parentClientValue?.ParentClientId === 0) {
      message = "Please check Parent client ";
    } else if (clientValue?.ClientId === 0) {
      message = "Please check Client ";
    } else if (programValue.ProgramId === 0) {
      message = "Please check Program ";
    } else if (projectValue.length === 1 && projectValue[0]?.ProjectId === 0) {
      message = "Please check Project ";
    } else if (selectedCountry.Country === "") {
      message = "Please check Country ";
    } else if (
      selectedSite.length === 1 &&
      selectedSite[0].GeoLocationId === 0
    ) {
      message = "Please check Site ";
    } else if (effectiveDateRef.current.value === "") {
      message = "Please provide effective date.";
    } else if (
      effectiveDateRef.current.value !== "" &&
      expiryDateRef.current.value !== "" &&
      effectiveDateRef.current.value > expiryDateRef.current.value
    ) {
      message = "Effective date cannot be greater than expiry date.";
    }
    return message;
  };

  const cascadeProjects = (value, filterBy) => {
    if (filterBy === "client") {
      const projects = allProjectData.filter(
        (item) => item?.ClientId === value?.ClientId,
      );
      setProjectData(projects);
    } else if (filterBy === "program") {
      const projects = allProjectData.filter(
        (item) => item?.ProgramId === value?.ProgramId,
      );
      setProjectData(projects);
    }
  };

  const handleCreateUpdateFramework = async (mode) => {
    try {
      setLoader(true);
      const message = validateFields();
      if (message === "Valid") {
        const payload = prepareUpdatePayload(mode);
        const response =
          mode === create
            ? await createFramework(payload)
            : await updateFramework(payload);
        if (response.message === "Success") {
          setLoader(false);
          setSnack({
            open: true,
            message: `${mode === create ? "Created" : "Updated"} successfully.`,
            severity: "success",
          });
          const newFrameworkId = response?.data[0]?.FrameworkId;
          if (mode === create) {
            navigate(`/learnpoint/infoSection/Classes/`, {
              state: {
                action: "createdFramework",
                frameworkId: newFrameworkId,
              },
            });
          }
        } else {
          setLoader(false);
          setSnack({
            open: true,
            message: "Some internal error occured.",
            severity: "error",
          });
        }
      } else {
        setLoader(false);
        setSnack({
          open: true,
          message: message,
          severity: "warning",
        });
      }
    } catch (e) {
      setLoader(false);
    }
  };

  const prepareUpdatePayload = (mode) => {
    return {
      ...(mode === update && { frameworkId: frameworkId }),
      // name: frameworkNameRef.current.value,
      description: frameworkDescriptionRef.current.value,
      classTypeId: classTypeValue?.ClassTypeId,
      projectIds: projectValue.map((item) => ({ projectId: item?.ProjectId })),
      geoLocationIds: selectedSite.map((item) => ({
        geoLocationId: item?.GeoLocationId,
      })),
      effectiveDate: effectiveDateRef.current.value,
      expireDate: moment(expiryDateRef.current.value).isValid()
        ? expiryDateRef.current.value
        : null,
      requireOneOnOnes: 0,
      ...(mode === create
        ? { createdBy: localStorage.getItem("User") }
        : { modifiedBy: localStorage.getItem("User") }),
    };
  };

  const hasEditAccess = hasPermission("LD_Group_Admin");

  return (
    <>
      {loader ? <BackdropComponent /> : null}

      <Grid container spacing={1} className={classes.gridContainer}>
        <Grid item xs={1.5}>
          <p className={classes.fieldText}>Framework Name :</p>
        </Grid>
        <Grid item xs={4}>
          <TextField
            placeholder="FRAMEWORK NAME [WILL BE SYSTEM GENERATED]"
            className={classes.searchField}
            inputRef={frameworkNameRef}
            disabled
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 32,
                border: "1px solid #d3d3d3",
                "& fieldset": {
                  border: "none",
                },
              },
            }}
          />
        </Grid>
        <Grid item xs={0.5}></Grid>
        <Grid item xs={1}>
          <p className={classes.fieldText}> Parent client : </p>
        </Grid>
        <Grid item xs={4}>
          <Autocomplete
            disablePortal
            blurOnSelect
            options={parentClientDetail}
            disabled={!hasEditAccess}
            value={parentClientValue}
            onChange={handleParentClientChange}
            getOptionLabel={(option) =>
              option?.ParentClientName === "" ? "" : option?.ParentClientName
            }
            sx={{
              opacity: 1,
              borderWidth: 1,
              borderStyle: "solid",
              borderColor: "gray",
              borderRadius: 32,
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 32,
                    border: "1px solid #d3d3d3",
                    "& fieldset": {
                      border: "none",
                    },
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={1.5}>
          <p className={classes.fieldText}>Description :</p>
        </Grid>
        <Grid item xs={4}>
          <TextField
            placeholder="MAXIMUM 500 CHARACTERS"
            multiline
            maxRows={4}
            size="small"
            disabled={!hasEditAccess}
            className={classes.searchField}
            inputRef={frameworkDescriptionRef}
            inputProps={{
              maxLength: 500,
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 32,
                border: "1px solid #d3d3d3",
                "& fieldset": {
                  border: "none",
                },
              },
            }}
          />
        </Grid>
        <Grid item xs={0.5}></Grid>
        <Grid item xs={1}>
          <p className={classes.fieldText}> Client : </p>
        </Grid>
        <Grid item xs={4}>
          <Autocomplete
            blurOnSelect
            disablePortal
            value={clientValue}
            disabled={!hasEditAccess}
            options={clientData}
            onChange={(event, value) => {
              if (value) {
                setClientValue(value);
                setProgramValue(initialProgramValue);
                setProjectValue([]);
                cascadeProjects(value, "client");
              } else {
                setClientValue(initialClientValue);
              }
            }}
            getOptionLabel={(option) =>
              option?.ClientName === "" ? "" : option?.ClientName
            }
            sx={{
              opacity: 1,
              borderWidth: 1,
              borderStyle: "solid",
              borderColor: "gray",
              borderRadius: 32,
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 32,
                    border: "1px solid #d3d3d3",
                    "& fieldset": {
                      border: "none",
                    },
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={1.5}>
          <p className={classes.fieldText}> Country : </p>
        </Grid>
        <Grid item xs={3.8}>
          <Autocomplete
            blurOnSelect
            disablePortal
            options={countryData}
            disabled={!hasEditAccess}
            value={selectedCountry}
            onChange={handleCountryChange}
            getOptionLabel={(option) =>
              option?.Country === "" ? "" : option?.Country
            }
            sx={{
              opacity: 1,
              borderWidth: 1,
              borderStyle: "solid",
              borderColor: "gray",
              borderRadius: 32,
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 32,
                    border: "1px solid #d3d3d3",
                    "& fieldset": {
                      border: "none",
                    },
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={0.7}></Grid>
        <Grid item xs={1}>
          <p className={classes.fieldText}> Program : </p>
        </Grid>
        <Grid item xs={4}>
          <Autocomplete
            blurOnSelect
            disablePortal
            value={programValue}
            disabled={!hasEditAccess}
            options={programData}
            onChange={(event, value) => {
              if (value) {
                setProgramValue(value);
                setProjectValue([]);
                cascadeProjects(value, "program");
              } else {
                setProgramValue(initialProgramValue);
              }
            }}
            getOptionLabel={(option) =>
              option.ProgramName === "" ? "" : option?.ProgramName
            }
            sx={{
              opacity: 1,
              borderWidth: 1,
              borderStyle: "solid",
              borderColor: "gray",
              borderRadius: 32,
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 32,
                    border: "1px solid #d3d3d3",
                    "& fieldset": {
                      border: "none",
                    },
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={1.5}>
          <p className={classes.fieldText}>Site : </p>
        </Grid>
        <Grid item xs={3.8}>
          <Autocomplete
            multiple
            disablePortal
            options={siteData}
            disabled={!hasEditAccess}
            value={selectedSite}
            onChange={(event, value, reason) => {
              if (value) {
                setSelectedSite(value);
              }
              if (reason === "clear") {
                setSelectedSite([]);
              }
            }}
            getOptionLabel={(option) =>
              option?.GeoLocCd === ""
                ? ""
                : `${option?.GeoLocName}(${option?.GeoLocCd})`
            }
            sx={{
              opacity: 1,
              borderWidth: 1,
              borderStyle: "solid",
              borderColor: "gray",
              borderRadius: 32,
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 32,
                    border: "1px solid #d3d3d3",
                    "& fieldset": {
                      border: "none",
                    },
                  },
                }}
              />
            )}
            renderTags={(value, getTagProps) => {
              const limitTags = 1;
              const more = value.length - limitTags;
              const tooltipText = value
                .map((v) => `${v.GeoLocName} (${v.GeoLocCd})`)
                .join(", ");
              return (
                <Tooltip title={tooltipText} arrow>
                  {value.slice(0, limitTags).map((option, index) => (
                    <StyledChip
                      label={`${option.GeoLocName} (${option.GeoLocCd})`}
                      size="small"
                      {...getTagProps({ index })}
                    />
                  ))}
                  {more > 0 && <LimitChip label={`+${more}`} size="small" />}
                </Tooltip>
              );
            }}
            renderOption={(props, option, state) => (
              <li {...props} key={option.GeoLocationId}>
                {`${option?.GeoLocName}(${option?.GeoLocCd})`}
                &nbsp;
                {state.selected && (
                  <CheckIcon fontSize="small" sx={{ color: "#3299FF" }} />
                )}
              </li>
            )}
          />
        </Grid>
        <Grid item xs={0.7}></Grid>
        <Grid item xs={1}>
          <p className={classes.fieldText}>Project :</p>
        </Grid>
        <Grid item xs={4}>
          <Autocomplete
            multiple
            disabled={!hasEditAccess}
            options={projectData}
            value={projectValue}
            getOptionLabel={(option) =>
              option?.ProjectName === "" ? "" : option?.ProjectName
            }
            onChange={(event, value, reason) => {
              if (value) {
                setProjectValue(value);
              }

              if (reason === "clear") {
                setProjectValue([]);
              }
            }}
            sx={{
              opacity: 1,
              borderWidth: 1,
              borderStyle: "solid",
              borderColor: "gray",
              borderRadius: 32,
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 32,
                    border: "1px solid #d3d3d3",
                    "& fieldset": {
                      border: "none",
                    },
                  },
                }}
              />
            )}
            renderTags={(value, getTagProps) => {
              const limitTags = 1;
              const more = value.length - limitTags;
              const tooltipText = value
                .map((v) => `${v.ProjectName} (${v.ProjectCode})`)
                .join(", ");
              return (
                <Tooltip title={tooltipText} arrow>
                  {value.slice(0, limitTags).map((option, index) => (
                    <StyledChip
                      label={`${option.ProjectName} (${option.ProjectCode})`}
                      size="small"
                      {...getTagProps({ index })}
                    />
                  ))}
                  {more > 0 && <LimitChip label={`+${more}`} size="small" />}
                </Tooltip>
              );
            }}
            renderOption={(props, option, state) => (
              <li {...props} key={option.ProjectId}>
                {option?.ProjectName}
                &nbsp;
                {state.selected && (
                  <CheckIcon fontSize="small" sx={{ color: "#3299FF" }} />
                )}
              </li>
            )}
          />
        </Grid>
        <Grid item xs={1.5}>
          <p className={classes.fieldText}>Effective Date :</p>
        </Grid>
        <Grid item xs={4}>
          <TextField
            type="date"
            className={classes.searchField}
            defaultValue=""
            disabled={!hasEditAccess}
            inputRef={effectiveDateRef}
            onChange={(event) => {
              effectiveDateRef.current.value = event.target.value;
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 32,
                border: "1px solid #d3d3d3",
                "& fieldset": {
                  border: "none",
                },
              },
            }}
          />
        </Grid>
        <Grid item xs={0.5}></Grid>
        <Grid item xs={1}>
          <p className={classes.fieldText}>Class Type :</p>
        </Grid>
        <Grid item xs={4}>
          <Autocomplete
            disablePortal
            blurOnSelect
            disabled={action === update}
            options={classTypeData}
            value={classTypeValue}
            onChange={(event, value) => {
              if (value) {
                setClassTypeValue(value);
              } else {
                setClassTypeValue(initialClassTypeValue);
              }
            }}
            getOptionLabel={(option) =>
              option?.ClassTypeId === 0 ? "" : option?.ClassTypeName
            }
            sx={{
              opacity: 1,
              borderWidth: 1,
              borderStyle: "solid",
              borderColor: "gray",
              borderRadius: 32,
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 32,
                    border: "1px solid #d3d3d3",
                    "& fieldset": {
                      border: "none",
                    },
                  },
                }}
              />
            )}
          />
        </Grid>

        <Grid item xs={1.5}>
          <p className={classes.fieldText}>Expiry Date :</p>
        </Grid>
        <Grid item xs={4}>
          <TextField
            type="date"
            className={classes.searchField}
            defaultValue=""
            inputRef={expiryDateRef}
            onChange={(event) => {
              expiryDateRef.current.value = event.target.value;
            }}
            disabled={!hasEditAccess}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 32,
                border: "1px solid #d3d3d3",
                "& fieldset": {
                  border: "none",
                },
              },
            }}
          />
        </Grid>
        <Grid item xs={1.5} />
        <Grid item xs={0.8}>
          <CustomButton
            variant="contained"
            onClick={
              action === update
                ? () => handleCreateUpdateFramework(update)
                : () => handleCreateUpdateFramework(create)
            }
            disabled={!hasEditAccess}
          >
            {action === update ? "Update" : "Create"}
          </CustomButton>
        </Grid>
        <Grid item xs={1}>
          <CustomOutlinedButton
            variant="outlined"
            size="small"
            startIcon={<RestartAltIcon />}
            onClick={handleReset}
          >
            Reset
          </CustomOutlinedButton>
        </Grid>
        <Grid item xs={4}></Grid>
      </Grid>

      <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
    </>
  );
}

const classType = [
  { classTypeName: "New Hire", classTypeId: 1 },
  { classTypeName: "Conversion", classTypeId: 2 },
  { classTypeName: "Up-Training", classTypeId: 3 },
  { classTypeName: "Other", classTypeId: 4 },
];

CreateUpdateFramework.propTypes = {
  action: PropTypes.string.isRequired,
  frameworkId: PropTypes.number,
};
